import { render, staticRenderFns } from "./RoulettePage.vue?vue&type=template&id=34378c9a&scoped=true&"
import script from "./RoulettePage.vue?vue&type=script&lang=js&"
export * from "./RoulettePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34378c9a",
  null
  
)

export default component.exports